import { EStatusMatches } from '@/app/pages/sports/football/enums';
import { MatchApi } from '@/app/pages/sports/football/home/models';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

@Component({
  selector: 'app-vs-scores',
  standalone: true,
  imports: [],
  templateUrl: './vs-scores.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VsScoresComponent {
  match = input.required<MatchApi>();

  homePenaltyScore = computed(() => `( ${this.match().HomePenaltyScore} )`);
  awayPenaltyScore = computed(() => `( ${this.match().AwayPenaltyScore} )`);

  hasScore(): boolean {
    return (
      !(
        this.match().Status === EStatusMatches.UPCOMING ||
        this.match().Status === EStatusMatches.DELAYED
      ) &&
      this.match().AwayScore >= 0 &&
      this.match().HomeScore >= 0
    );
  }

  isLiveMatch(): boolean {
    return this.match().Status === EStatusMatches.NORMAL;
  }
}
